import axios from "../../axios";

const urlPage = "/landing-pages";
const urlUpdateStatus = "/landing-pages-make-status";
const urlPageDeleteMultiple = "/landing-pages-multi-delete";

const state = {
  pages: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * getListPages
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListPages({ commit }, query) {
    const response = await axios.get(
      `${urlPage}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_PAGES", response.data.data);
    }

    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async getDetailLandingPage({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlPage}/${id}?${new URLSearchParams(payload)}`)
        .then((response) => {
          resolve(response.data ?? {});
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * createPage
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createPage({ commit }, payload) {
    return await axios.post(urlPage, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * updatePage
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateStatusPage({ commit }, { id, payload }) {
    return await axios.post(`${urlPage}/${id}${urlUpdateStatus}`, payload);
  },

  /**
   * updatePage
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updatePage({ commit }, { id, payload }) {
    return await axios.post(`${urlPage}/${id}?_method=PUT`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * deletePage
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deletePage({ commit }, id) {
    return await axios.delete(`${urlPage}/${id}`);
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post(`${urlPage}${urlPageDeleteMultiple}`, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_PAGES(state, data) {
    if (data) {
      state.pages = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
